import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import MediaPlayer from '../components/MediaPlayer';
import { listTestimonies } from '../services/testimonyService';

const Testimonies = () => {
  const [testimonies, setTestimonies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const itemsPerPage = 4;

  useEffect(() => {
    const loadTestimonies = async () => {
      const data = await listTestimonies({ approvedOnly: true });
      setTestimonies(data);
      setIsLoading(false);
    };
    loadTestimonies();
  }, []);

  const totalPages = Math.ceil(testimonies.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentTestimonies = testimonies.slice(startIndex, startIndex + itemsPerPage);

  return (
    <>
      <div className="container-fluid page-top">
        <div className="container">
          <div className="row">
            <h2>Testimonios</h2>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="py-4">
              {isLoading ? (
                <LoadingSpinner label="Cargando testimonios..." />
              ) : (
                currentTestimonies.map(testimony => (
                  <div key={testimony.id} className="card mb-3">
                    <div className="card-body">
                      <h5 className="card-title">{testimony.title}</h5>
                      <h6 className="card-subtitle mb-2 text-muted">
                        {testimony.name} {testimony.dni ? `- ${testimony.dni}` : ''}
                      </h6>
                      <div
                        className="card-text"
                        dangerouslySetInnerHTML={{ __html: testimony.contentHtml }}
                      />
                      {(testimony.audioUrl || testimony.videoUrl) && (
                        <MediaPlayer audioUrl={testimony.audioUrl} videoUrl={testimony.videoUrl} />
                      )}
                      <small className="text-muted">{testimony.date}</small>
                    </div>
                  </div>
                ))
              )}
              
              {totalPages > 1 && (
                <nav>
                  <ul className="pagination justify-content-center">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>Anterior</button>
                    </li>
                    {[...Array(totalPages)].map((_, index) => (
                      <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                        <button className="page-link" onClick={() => setCurrentPage(index + 1)}>{index + 1}</button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>Siguiente</button>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Testimonies;